import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';

export type IconProps = Omit<FontAwesomeIconProps, 'ref'>;

export const Icon = (props: IconProps) => {
	'use memo';

	// Template
	// ------------------------------------------------------------------------

	return <FontAwesomeIcon {...props} />;
};
